import {Component, EventEmitter, HostListener, Inject, Input, OnInit, Output} from '@angular/core'
import {DOCUMENT} from '@angular/common'
import {RichsnipetService} from 'dmmp-services'
import {RemoveHtmlPipe} from '../../pipes/removeHtml.pipe'

@Component({
  selector: 'dmmp-website-box-float-program',
  templateUrl: './website-box-float-program.component.html',
})
export class WebsiteBoxFloatProgramComponent implements OnInit {
  @Input() identifier
  @Input() data
  @Input() module
  @Output() page = new EventEmitter()
  @Input() urlPayment
  @Input() privateKey
  classScroll: boolean
  classScrollMobile: boolean
  schemaItem = []
  description

  constructor(@Inject(DOCUMENT) private _document,
              private richsnipetService: RichsnipetService,
              private removeHtmlPipe: RemoveHtmlPipe) {
  }

  ngOnInit() {
    if (this.data) {
      this.schemaItem = this.richsnipetService.setupJsonCourse([{
        title: this.data.title ? this.data.title : '',
        description: this.data.description ? this.removeHtmlPipe.transform(this.data.description) : '',
        university: this.data.university && this.data.university.length > 0 ? this.data.university : [],
      }])
    }
  }

  @HostListener('window:scroll', [])
  public onScrollEvent(): void {
    const header = this._document.querySelector('header')
    const heightHeader = header ? header.offsetHeight : 64
    this.classScroll = window.scrollY > heightHeader + 120
    this.classScrollMobile = window.scrollY > 0
  }
}
